import { setupAnalytics } from '../components/analytics/default';
import { loginSuccess } from '../components/analytics/events/login';
import { loginFormHandler } from '../components/login';

const analytics = setupAnalytics();

export default function () {
    (function ($) {
        var loginModal = $('#LoginModal'); // Assumes there's only 1 login modal

        // e.g $('.modal').loadLoginForm()
        $.fn.loadLoginForm = function (src, force, callback) {
            var that = this;
            // Preserve the source
            $(this).attr('data-src', src);

            // Pre-load the modal content
            if (force || !$.trim($(this).find('.modal-body').html()).length) {
                $(this).find('.modal-body').load(src, function () {
                    // Validation
                    $(this).find('#MemberLoginForm_LoginForm').initLoginValidation();
                    // Callback after content is loaded
                    if (typeof callback === 'function') {
                        callback.call(that);
                    }
                });
            } else {
                // Callback anyway
                if (typeof callback === 'function') {
                    callback.call(that);
                }
            }
        };

        $.fn.resetLoginForm = function () {
            var form = $(this).find('#MemberLoginForm_LoginForm');

            // Reset fields
            form.find('input[type="text"], input[type="password"]').val('');
            form.find('input[type="checkbox"]').prop('checked', false);
            $(this).clearLoginFormErrors();
        };

        // Clears errors from a specific element
        $.fn.clearLoginFormErrors = function () {
            var form = $(this).find('#MemberLoginForm_LoginForm');
            var validator = form.validate();

            // Assumes errors are always in a specific id
            $(this).find('#MemberLoginForm_LoginForm_error').empty().removeClass('bad');

            // Reset validation
            if (validator) {
                form.find('input[type="text"], input[type="password"]').removeClass('error');
                validator.resetForm();
            }
        };

        // Handles opening the login modal
        $('[data-target="#LoginModal"]').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $($(this).attr('data-target')).loadLoginForm($(this).attr('href'), false, function () {
                $(this).modal('show');

                loginFormHandler.prefillLoginFormDetails();
            });
        });

        // Handles submitting the login form
        loginModal.on('submit', '#MemberLoginForm_LoginForm', function (event) {

            var form = $(event.currentTarget);
            var modal = $(this).closest('#LoginModal');

            modal.clearLoginFormErrors();

            if (form.valid()) {
                disableLoginButton();

                $.ajax({
                    type: form.attr('method'),
                    url: form.attr('action'),
                    data: form.serialize(),
                    success: function (json) {
                        // We want the response data to be captured raw so 200 with non-valid json
                        // are still successful
                        let data;

                        loginFormHandler.manageRememberEmailForDevice();

                        try {
                            data = JSON.parse(json);
                        } catch (e) {
                            // Still successful (but without meaningful data from the response)
                            // so let's reload
                            window.location.reload();
                            return;
                        }

                        analytics.resetIdentity();
                        // user id is required to track user across applications e.g. web, ios, android etc.
                        analytics.trackEvent(loginSuccess({
                            userId: data.userId,
                        }));

                        if (data.redirect && data.location) {
                            // Handle a redirect
                            window.location.replace(data.location);
                            return;
                        }

                        // Fallback to a reload
                        window.location.reload();
                    },
                    error: function () {
                        // Authentication failed
                        // Re-load to get form error state from ajax source
                        // Assumes data-src is defined
                        modal.loadLoginForm(modal.attr('data-src'), true);
                    },
                });

                return false;
            }

            return false;
        });

        loginModal.on('show.bs.modal hidden.bs.modal', function () {
            $(this).resetLoginForm();
        });

        // trigger modal for going out of adviser view
        $('a').on('click touch', function (e) {
            // this solution assumes there's only 1 string in the url that is 'secure'
            if ($('.impersonation-overlay').length && $(this).attr('href').indexOf("secure") < 0 && $(this).data('target') !== '#NotAvailable' && $(this).data('toggle') !== 'tab') {
                let url = $(this).attr('href');
                e.preventDefault();
                e.stopPropagation();
                let modal = $('#ExitAdviserView').modal('show');
                modal.find('#Form_ImpersonationExitForm_ExitURL').val(url);
            }
        });

        const disableLoginButton = () => {
            const loginButton = $('#MemberLoginForm_LoginForm_action_doLogin');

            if (loginButton.length < 1) {
                return;
            }

            loginButton.prop('disabled', true);
        };
    })(jQuery);
}
